module.exports = __webpack_public_path__ + "img/2CC1A3C9-7FC7-42f0-8EA6-DF7BDC8530EC.69a571b5.png";